import React, { FC } from "react"
import {
  HasSidebarLayout,
  ListHeader,
  TabGroupFilter,
  EventTypeList,
  BuildingTypeList,
  ProjectTypeList,
  ProductTypeList,
  ConfigurationList,
  SensorParams,
  ReportTypeList,
  CombinedReportSettings,
  MobileSettingsParams,
  AlertSettingsParams,
  ContractorTransferHistory,
} from "src/components"
import { SearchParamsKeys } from "src/enums"

const getUserListTabs = () => [
  {
    status: "Event Types",
    content: <EventTypeList />,
  },
  {
    status: "Building Types",
    content: <BuildingTypeList />,
  },
  {
    status: "Project Types",
    content: <ProjectTypeList />,
  },
  {
    status: "Product Categories",
    content: <ProductTypeList />,
  },
  {
    status: "Report Types",
    content: <ReportTypeList />,
  },
  {
    status: "Combined report",
    content: <CombinedReportSettings />,
  },
  {
    status: "General",
    content: <ConfigurationList />
  },
  {
    status: "Sensor",
    content: <SensorParams />
  },
  {
    status: "Mobile Settings",
    content: <MobileSettingsParams />
  },
  {
    status: "Alert Settings",
    content: <AlertSettingsParams />
  },
  {
    status: "Transfer",
    content: <ContractorTransferHistory />
  }
]

const SettingsTabs: FC = () => {
  const tabs = getUserListTabs()
  // the Transfer tab pages its history through the URL, so the paging keys must not leak into the next tab
  return <TabGroupFilter name={SearchParamsKeys.Tab} statusList={tabs} paramsToRemove={[SearchParamsKeys.Page, SearchParamsKeys.RowsPerPage]} />
}

const SettingsList: FC = () => {
  document.title = 'CLīMIT Admin Panel - Settings'
  return (
    <HasSidebarLayout>
      <ListHeader title="Settings" />
      <SettingsTabs />
    </HasSidebarLayout>
  )
}

export default SettingsList
